export default __webpack_public_path__ + "static/media/auto-exterior-color.e70c4e75.svg";